import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { numberConvert } from "@website/utils/number-convert";
import snappProBadge from "@website/widget/header/assets/pro_badge.svg";
import { FC } from "react";
import { SnappProDiscountChipProperties } from "./snapp-pro-discount-chip.types";
export const SnappProDiscountChip: FC<SnappProDiscountChipProperties> = t0 => {
  const $ = _c(9);
  const {
    className,
    showDesc,
    percentage
  } = t0;
  const t1 = `bg-light-mode-pro-light flex items-center gap-[6px] rounded-[4px] px-2 py-1 ${className ?? ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LazyImage src={snappProBadge.src} alt="Snapp Pro" width={24} height={14} />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== percentage) {
    t3 = numberConvert(percentage, {
      locale: "fa"
    });
    $[1] = percentage;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = showDesc ? " \u0647\u0646\u06AF\u0627\u0645 \u067E\u0631\u062F\u0627\u062E\u062A" : "";
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = <span className="text-light-mode-pro text-[12px] font-medium">{t3}٪ تخفیف پرو{t4}</span>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t1 || $[7] !== t5) {
    t6 = <div className={t1}>{t2}{t5}</div>;
    $[6] = t1;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};